import styled, { css } from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledInput = styled.input`
    cursor: pointer;
`;

export const StyledIconContainer = styled.div`
    left: 16px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const StyledFieldContainer = styled.div<{ hasIcon: boolean; isHighlightedOnFocus: boolean }>`
    position: relative;

    ${StyledInput} {
        ${mixins.setFont({ $size: 14, $color: colorsPalettes.carbon["400"], $weight: 400 })};
        border: 1px solid ${colorsPalettes.midnight["50"]};
        border-radius: 3px;
        box-shadow: none;
        display: block;
        height: 40px;
        line-height: 16px;
        margin: 0;
        padding-left: ${({ hasIcon }) => (hasIcon ? 48 : 16)}px;
        padding-right: 16px;
        width: 100%;

        &:focus {
            border-color: ${({ isHighlightedOnFocus }) =>
                isHighlightedOnFocus ? colorsPalettes.blue["400"] : colorsPalettes.midnight["50"]};
            ${({ isHighlightedOnFocus }) =>
                isHighlightedOnFocus &&
                css`
                    box-shadow: 0 3px 5px rgba(42, 62, 82, 0.12);
                `};
        }

        &::placeholder {
            color: ${colorsPalettes.carbon["200"]};
        }
    }
`;
